import {
    Backdrop, Box,
    Button,
    Container, Divider, Fade,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem, Modal,
    Radio,
    RadioGroup,
    Select, Table, TableBody, TableContainer, TableHead, TableRow,
    TextField, Typography,
    Accordion, AccordionSummary, AccordionDetails
} from '@material-ui/core'

import React, {useEffect, useState} from "react";
import {useStyles} from "./styles";
import Preloader from "../shared/Preloader/Preloader";
import {Alert} from "@material-ui/lab";
import {SUPPORT_EMAIL, URL_FOR_API} from "../../constants/constants";
import {StatesType} from "../../types/stateType";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../reducers/rootReducers";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import actionsWithApi from "../../customHooks/actionsWithApi";
import {NavLink, useParams, useLocation} from "react-router-dom";
import {history} from "../../../App";
import getCookie from "../../scripts/getCookie";
import {setNotificationInfo, toggleNotification} from "../../actions/actions";
import Paper from "@material-ui/core/Paper";
import {StyledTableCell, StyledTableRow} from "./styled";
import {
    CommentFormData, ContractStatus,
    defaultCommentFormData,
    defaultFormData,
    DraftContract,
    FormData, StatusNameMap,
} from "./types";
import WarningIcon from "@material-ui/icons/Warning";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import dateFormatting from "../../scripts/dateFormatting";


export default function DraftContractPage() {
    const {id} = useParams<{ id: string }>()
    const token = getCookie("token")
    const location = useLocation();
    const [loaderIsActive, setLoaderIsActive] = useState<boolean>(false);
    const dispatch = useDispatch();
    const isAdministrator = getCookie("currentUserRole") === "Administrator";
    const classes = useStyles();
    let states: Array<StatesType> = useSelector((state: RootState) => state.states);
    const [isMismatchInfoModalOpen, setIsMismatchInfoModalOpen] = useState<boolean>(false);
    const [isHaveAccess, setIsHaveAccess] = useState<boolean>(false);
    const [isStatusLoaded, setIsStatusLoaded] = useState<boolean>(false);
    const [isContractLoaded, setIsContractLoaded] = useState<boolean>(false);
    const [contractId, setContractId] = useState<number>(0);
    const [isApprovedContractModalOpen, setIsApprovedContractModalOpen] = useState<boolean>(false);
    const [mismatchData, setMismatchData] = useState<any[]>([]);
    const [statusComments, setStatusComments] = useState<string>('');
    const [accidentDate, setAccidentDate] = useState<string>(new Date().toISOString());
    const [plaintiffDateOfBirth, setPlaintiffDateOfBirth] = useState<string>(new Date().toISOString());
    const [settlementDate, setSettlementDate] = useState<string>(new Date().toISOString());
    const [draftContract, setDraftContract] = useState<DraftContract | null>(null);
    const [commentFormData, setCommentFormData] = useState<CommentFormData>(defaultCommentFormData);
    const [formData, setFormData] = useState<FormData>(defaultFormData);
    const isValidDate = (value: string | Date): boolean => {
        const date = value instanceof Date ? value : new Date(value);
        return !isNaN(date.getTime());
    };

    const handleDate = (date: any, name: string) => {
        try {
            if (isValidDate(date)) {
                setFormData(prev => ({
                    ...prev,
                    [name]: date.toISOString()
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
            switch (name) {
                case 'settlementDate':
                    setSettlementDate(date);
                    break;
                case 'plaintiffDateOfBirth':
                    setPlaintiffDateOfBirth(date);
                    break;
                case 'accidentDate':
                    setAccidentDate(date);
                    break;
                default:
                    break;
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    }

    const handleInputChange = (e: any) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleStatusComments = (e: any) => {
        const {value} = e.target;
        setStatusComments(value);
    };

    const handleInputCommentChange = (e: any) => {
        const {name, value} = e.target;
        setCommentFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSelectChange = (e: any) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleLiabilityChange = (e: any) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value === 'yes',
            liabilityValue: value
        }));
    };

    const handleBooleanChange = (e: any) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value === 'yes',
        }));
    };

    const checkStatus = async (id: string) => {
        try {
            const response = await actionsWithApi("POST", URL_FOR_API + `/api/v1/ContractDraft/access/${id}`);
            if (response && response.status === 200) {
                setIsStatusLoaded(true);
                setIsHaveAccess(response.data.hasAccess);
                if (response.data.hasAccess) {
                    getContract(id);
                }
            }
        } catch (e) {
            console.error('Error fetching contract status:', e);
            history.push(`/contract-drafts`);
        }
    }

    const getContract = async (id: string) => {
        try {
            const response = await actionsWithApi("GET", URL_FOR_API + `/api/v1/ContractDraft/get/${id}`);
            if (response && response.status === 200) {
                setDraftContract(response.data);
                setIsContractLoaded(true);
                setFormData({
                    ...response.data,
                    liabilityValue: response.data.liability ? 'yes' : 'no',
                });
                setPlaintiffDateOfBirth(response.data.plaintiffDateOfBirth);
                setSettlementDate(response.data.settlementDate);
                setAccidentDate(response.data.accidentDate);
                const adminNotes = Object.entries(response.data.adminNotes).reduce<Record<string, typeof response.data.adminNotes[keyof typeof response.data.adminNotes]>>(
                    (acc, [key, value]) => {
                        const newKey = key.charAt(0).toLowerCase() + key.slice(1);
                        acc[newKey] = value;
                        return acc;
                    },
                    {}
                );
                if (response.data.actualStatus === ContractStatus.APPROVED) {
                    setContractId(response.data.contractId);
                }
                setCommentFormData(adminNotes as CommentFormData);
            }
        } catch (e) {
            console.error('Error fetching contract:', e);
            history.push(`/contract-drafts`);
        }
    }

    const reject = async () => {
        try {
            const data: { statusComments?: string } = {};
            if (statusComments.length > 0) {
                data['statusComments'] = statusComments;
            }
            const response = await actionsWithApi("POST", URL_FOR_API + `/api/v1/ContractDraft/decline/${id}`, data);
            if (response && response.status === 200) {
                dispatch(setNotificationInfo({message: "Contract successfully declined", severity: "success"}))
                dispatch(toggleNotification(true))
                history.push(`/contract-drafts`)
            }
        } catch (e) {
            dispatch(setNotificationInfo({message: e.message, severity: "error"}))
            dispatch(toggleNotification(true));
        }
    }

    const approve = async () => {
        try {
            const response = await actionsWithApi("POST", URL_FOR_API + `/api/v1/ContractDraft/approve/${id}`);
            if (response && response.status === 200) {
                dispatch(setNotificationInfo({message: "Contract successfully approved", severity: "success"}))
                dispatch(toggleNotification(true));
                history.push(`/contract-page?${response.data.id}`)
            }
        } catch (e) {
            dispatch(setNotificationInfo({message: e.message, severity: "error"}))
            dispatch(toggleNotification(true));
        }
    }

    const validate = async (userType: 'client' | 'attorney' | 'lawFirm') => {
        try {
            const clientData = {
                firstName: formData.plaintiffFirstName,
                lastName: formData.plaintiffLastName,
                email: formData.plaintiffEmail,
                dateOfBirth: formData.plaintiffDateOfBirth,
                address: formData.plaintiffStreetAddress,
                city: formData.plaintiffCity,
                postalCode: formData.plaintiffPostalCode,
                phone: formData.plaintiffPhone,
                stateId: formData.plaintiffStateId,
            };
            const attorneyData = {
                firstName: formData.attorneyFirstName,
                lastName: formData.attorneyLastName,
                email: formData.attorneyEmail,
                phone: formData.attorneyPhoneNumber,
                stateId: formData.attorneyStateId,
            }
            const lawFirmData = {
                name: formData.lawFirmName,
                stateId: formData.lawFirmStateId,
            }
            let data = {
                type: userType,
            }
            switch (userType) {
                case 'client':
                    data = {
                        ...data,
                        ...clientData
                    };
                    break;
                case 'attorney':
                    data = {
                        ...data,
                        ...attorneyData,
                    }
                    break;
                case 'lawFirm':
                    data = {
                        ...data,
                        ...lawFirmData,
                    }
                    break;
                default:
                    break;
            }
            const response = await actionsWithApi("POST", URL_FOR_API + `/api/v1/ContractDraft/validate-user/`, data);
            if (response && response.status === 200) {
                if (response.data.isSuccess) {
                    dispatch(setNotificationInfo({message: response.data.message, severity: "success"}));
                    dispatch(toggleNotification(true));
                } else {
                    dispatch(setNotificationInfo({message: response.data.message, severity: "error"}));
                    dispatch(toggleNotification(true));
                }
                const compareData = <T extends object, U extends object>(obj1: T, obj2: U): {
                    actualValue: any,
                    systemValue: any
                }[] => {
                    return Object.keys(obj1).map(key => ({
                        actualValue: obj1[key as keyof T],
                        systemValue: obj2[key as keyof U],
                    }));
                }
                if (response.data.status === 'InfoMismatch') {
                    let generatedData: { actualValue: any, systemValue: any }[] = [];
                    switch (userType) {
                        case 'client':
                            generatedData = compareData(clientData, response.data.userInfo);
                            break;
                        case 'attorney':
                            generatedData = compareData(attorneyData, response.data.userInfo);
                            break;
                        case 'lawFirm':
                            generatedData = compareData(lawFirmData, response.data.userInfo);
                            break;
                        default:
                            break;
                    }
                    setMismatchData(generatedData)
                    setIsMismatchInfoModalOpen(true);
                }
            }
        } catch (e) {
            dispatch(setNotificationInfo({message: e.message, severity: "error"}))
            dispatch(toggleNotification(true));
        }
    }

    // The update-review-update "ping-pong" flow is retired: clients and attorneys tend to ignore
    // the system emails, so the admin now reviews the draft, contacts the attorney manually and
    // edits the draft on their own. Kept commented out in case the flow comes back.
    // const requestChanges = async () => {
    //     try {
    //         const data = Object.fromEntries(
    //             Object.entries(commentFormData).filter(([_, value]) => value !== '' && value != null)
    //         );
    //         if (statusComments.length > 0) {
    //             data['statusComments'] = statusComments;
    //         }
    //         const response = await actionsWithApi("POST", URL_FOR_API + `/api/v1/ContractDraft/request-changes/${id}`, data);
    //         if (response && response.status === 200) {
    //             dispatch(setNotificationInfo({message: "Changes from client successfully requested", severity: "success"}))
    //             dispatch(toggleNotification(true))
    //             history.push(`/contract-drafts`)
    //         }
    //     } catch (e) {
    //         dispatch(setNotificationInfo({message: e.message, severity: "error"}))
    //         dispatch(toggleNotification(true));
    //     }
    // }
    //
    // const requestAttorneyChanges = async () => {
    //     try {
    //         const data = Object.fromEntries(
    //             Object.entries(commentFormData).filter(([_, value]) => value !== '' && value != null)
    //         );
    //         if (statusComments.length > 0) {
    //             data['statusComments'] = statusComments;
    //         }
    //         const response = await actionsWithApi("POST", URL_FOR_API + `/api/v1/ContractDraft/request-info-from-attorney/${id}`, data);
    //         if (response && response.status === 200) {
    //             dispatch(setNotificationInfo({message: "Changes from attorney successfully requested", severity: "success"}))
    //             dispatch(toggleNotification(true))
    //             history.push(`/contract-drafts`)
    //         }
    //     } catch (e) {
    //         dispatch(setNotificationInfo({message: e.message, severity: "error"}))
    //         dispatch(toggleNotification(true));
    //     }
    // }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoaderIsActive(true);
        if (draftContract && (draftContract.actualStatus === ContractStatus.DECLINED || draftContract.actualStatus === ContractStatus.APPROVED)) {
            dispatch(setNotificationInfo({
                message: `This draft was ${draftContract.actualStatus}, and can not be updated`,
                severity: "error"
            }))
            dispatch(toggleNotification(true));
            setLoaderIsActive(false);
            if (draftContract.actualStatus === ContractStatus.APPROVED) {
                setIsApprovedContractModalOpen(true);
            }
            return;
        }

        try {
            // Creation is anonymous ("save"), updates are admin-only ("update")
            const url = !!id ? "/api/v1/ContractDraft/update" : "/api/v1/ContractDraft/save";
            const response = await actionsWithApi("POST", URL_FOR_API + url, formData)
            if (response && response.status === 200) {
                if (!!id) {
                    dispatch(setNotificationInfo({
                        message: `Draft successfully updated`,
                        severity: "success"
                    }));
                    dispatch(toggleNotification(true));
                } else {
                    history.push(`/draft-contract-created`)
                }
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setLoaderIsActive(false);
        }
    };

    useEffect(() => {
        if (!id) {
            const currentDate = new Date().toISOString();
            setDraftContract(null);
            setFormData(defaultFormData);
            setPlaintiffDateOfBirth(currentDate);
            setSettlementDate(currentDate);
            setAccidentDate(currentDate);
            return;
        }
        checkStatus(id)
    }, [id]);

    useEffect(() => {
        if (draftContract && draftContract.actualStatus === ContractStatus.APPROVED) {
            setIsApprovedContractModalOpen(true);
        }
    }, [draftContract]);

    if (!token && location.pathname.includes('/contract-drafts')) {
        return (
            <h1 style={{ textAlign: 'center', padding: '20px 0' }}>Please, Login!</h1>
        )
    }

    return (
        <>
            {
                !!id && isStatusLoaded && !isHaveAccess && (
                    <Container maxWidth="lg" className={classes.draftContractPage}>
                        <div className={classes.alert}>
                            This contract draft is currently supposed to be edited by another user. Access is temporary restricted
                        </div>
                    </Container>
                )
            }
            {
                !!id && isStatusLoaded && isHaveAccess && !isContractLoaded && (
                    <Container maxWidth="lg" className={classes.draftContractPage}>
                        <div className={classes.alert}>
                            Loading contract draft
                        </div>
                    </Container>
                )
            }
            {
                ((!!id && isStatusLoaded && isContractLoaded && isHaveAccess) || !id) && (
                    <>
                        <Container maxWidth="lg" className={classes.draftContractPage}>
                            {
                                draftContract && draftContract.statusHistory && draftContract.statusHistory.length > 0 && (
                                    <Accordion className={classes.accordion}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <Typography>History</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell align="left">Date</StyledTableCell>
                                                        <StyledTableCell align="left">Status</StyledTableCell>
                                                        <StyledTableCell align="left">User</StyledTableCell>
                                                        <StyledTableCell align="left">Version</StyledTableCell>
                                                        <StyledTableCell align="left">Comment</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {draftContract.statusHistory.map((statusHistoryItem: any) => (
                                                        <StyledTableRow key={statusHistoryItem.id}>
                                                            <StyledTableCell
                                                                align="left">{dateFormatting(statusHistoryItem.statusDate)}</StyledTableCell>
                                                            <StyledTableCell
                                                                align="left">{StatusNameMap[statusHistoryItem.status]}</StyledTableCell>
                                                            <StyledTableCell
                                                                align="left">
                                                                {
                                                                    statusHistoryItem.dedicatedToUserId && statusHistoryItem.dedicatedToUserName ? (
                                                                        <>
                                                                            {
                                                                                token ? (
                                                                                    <NavLink to={`/user-profile?${statusHistoryItem.dedicatedToUserId}`}>
                                                                                        {
                                                                                            statusHistoryItem.dedicatedToUserName
                                                                                        }
                                                                                    </NavLink>
                                                                                ) : <>{statusHistoryItem.dedicatedToUserName}</>
                                                                            }
                                                                        </>
                                                                    ) : ('-')
                                                                }
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                align="left">{statusHistoryItem.targetVersion}</StyledTableCell>
                                                            <StyledTableCell
                                                                align="left">{statusHistoryItem.comments || '-'}</StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </AccordionDetails>
                                    </Accordion>
                                )
                            }
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <section className={classes.draftContractSection}>
                                    <Alert
                                        className={classes.alert}
                                        icon={false}
                                        severity="warning"
                                        variant="outlined"
                                    >
                                        <p>
                                            Please enter your creator email so we can contact you.
                                        </p>
                                    </Alert>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl} name="creatorEmail" variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   InputProps={{
                                                       readOnly: isAdministrator && !!draftContract || !!id,
                                                   }}
                                                   required
                                                   value={formData.creatorEmail}
                                                   type="email"
                                                   size="small"
                                                   onChange={(e) => handleInputChange(e)} label="Creator Email"/>
                                    </div>
                                </section>
                                <section className={classes.draftContractSection}>
                                    <div className={classes.formGroup}>
                                        <div className={classes.formBox}>
                                            <span className={classes.formControlLabel}>Select the Contract Type</span>
                                            <RadioGroup className={classes.radioButtons} row name="contractType"
                                                        defaultValue="PreSettlement"
                                                        onChange={(e) => handleInputChange(e)}>
                                                <FormControlLabel value="PreSettlement" control={<Radio color="primary"/>}
                                                                  label="Pre-Settlement" labelPlacement="end"/>
                                                <FormControlLabel value="PostSettlement" control={<Radio color="primary"/>}
                                                                  label="Post-Settlement" labelPlacement="end"/>
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <h2 className={classes.draftContractPageSubTitle}>Financial Information</h2>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl} name="requestedAmount" variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.requestedAmount}
                                                   type="number" size="small"
                                                   label="Funding Amount Requested" onChange={(e) => handleInputChange(e)}/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="requestedAmount"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.requestedAmount}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.requestedAmount && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.requestedAmount}
                                    </span>
                                            )
                                        }
                                    </div>
                                    {formData.contractType === "PostSettlement" &&
                                        <div className={classes.formGroup}>
                                            <TextField className={classes.formControl} name="settlementAmount" variant="outlined"
                                                       InputLabelProps={{
                                                           className: classes.formControlLabel,

                                                       }}
                                                       value={formData.settlementAmount}
                                                       type="number" size="small"
                                                       onChange={(e) => handleInputChange(e)} label="Settlement Amount"/>
                                            {
                                                isAdministrator && !!draftContract && (
                                                    <TextField className={classes.formControlComment} name="settlementAmount"
                                                               variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,
                                                               }}
                                                               value={commentFormData.settlementAmount}
                                                               size="small"
                                                               onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                )
                                            }
                                            {
                                                !!draftContract && !isAdministrator && commentFormData && commentFormData.settlementAmount && (
                                                    <span className={classes.adminNotes}>
                                            <WarningIcon className={classes.adminNotesIcon}/>
                                                        {commentFormData.settlementAmount}
                                        </span>
                                                )
                                            }
                                        </div>
                                    }
                                    {formData.contractType === "PreSettlement" &&
                                        <div className={classes.formGroup}>
                                            <FormControl className={classes.formControl}>
                                                <InputLabel id="estimated-settlement-amount" className={classes.formControlLabel}>Estimated
                                                    Settlement Amount</InputLabel>
                                                <Select label="estimated-settlement-amount" className={classes.formControl}
                                                        value={formData.estimatedSettlementAmount}
                                                        name="estimatedSettlementAmount" onChange={(e) => handleInputChange(e)}>
                                                    <MenuItem value="0-25k">0-25k</MenuItem>
                                                    <MenuItem value="26k-50k">26k-50k</MenuItem>
                                                    <MenuItem value="51k-100k">51k-100k</MenuItem>
                                                    <MenuItem value="101k-200k">101k-200k</MenuItem>
                                                    <MenuItem value="Over 201k">Over 201k</MenuItem>
                                                </Select>
                                            </FormControl>
                                            {
                                                isAdministrator && !!draftContract && (
                                                    <TextField className={classes.formControlComment} name="estimatedSettlementAmount"
                                                               variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,
                                                               }}
                                                               value={commentFormData.estimatedSettlementAmount}
                                                               size="small"
                                                               onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                )
                                            }
                                            {
                                                !!draftContract && !isAdministrator && commentFormData && commentFormData.estimatedSettlementAmount && (
                                                    <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                        {commentFormData.estimatedSettlementAmount}
                                    </span>
                                                )
                                            }
                                        </div>
                                    }
                                    <div className={classes.formGroup}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel id="amount-funds-for-future" className={classes.formControlLabel}>Estimated
                                                amount of funds needed in the future</InputLabel>
                                            <Select label="amodunt-funds-for-future" className={classes.formControl}
                                                    value={formData.estimatedAdditionalAmount}
                                                    name="estimatedAdditionalAmount" onChange={(e) => handleInputChange(e)}>
                                                <MenuItem value="None">None</MenuItem>
                                                <MenuItem value="500-1000">500-1000</MenuItem>
                                                <MenuItem value="1001-2000">1001-2000</MenuItem>
                                                <MenuItem value="2001-3000">2001-3000</MenuItem>
                                                <MenuItem value="Over 3000">Over 3000</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="estimatedAdditionalAmount"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.estimatedAdditionalAmount}
                                                           type="email"
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.estimatedAdditionalAmount && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.estimatedAdditionalAmount}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl} name="fundingRecipientEmail" variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.fundingRecipientEmail}
                                                   type="email"
                                                   size="small"
                                                   onChange={(e) => handleInputChange(e)} label="Funding Recipient Email"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="fundingRecipientEmail"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.fundingRecipientEmail}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.fundingRecipientEmail && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.fundingRecipientEmail}
                                    </span>
                                            )
                                        }
                                    </div>
                                </section>
                                <Divider className={classes.divider}/>
                                <section className={classes.draftContractSection}>
                                    <h2 className={classes.draftContractPageSubTitle}>
                                        Plaintiff Background
                                        {
                                            isAdministrator && !!draftContract && (
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => validate('client')}
                                                    disabled={loaderIsActive}
                                                >
                                                    Validate
                                                </Button>
                                            )
                                        }
                                    </h2>
                                    <p className={classes.draftContractPageSubText}>
                                        Type in the name of your desired Plaintiff below to search and select the right
                                        user. <br></br>
                                        If the person doesn't exist within the system, then click 'Create New Plaintiff' and add
                                        their personal information.
                                    </p>
                                    {formData.contractType === "PostSettlement"
                                        ? <Alert
                                            className={classes.alert}
                                            icon={false}
                                            severity="warning"
                                            variant="outlined"
                                        >
                                            <p>You can only request Post Settlement funding for Plaintiffs who have already received
                                                funding in a Pre-Settlement request.</p>
                                            <p>If your client doesn’t not have an approved Pre-Settlement request, please contact <a
                                                href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                                            </p>
                                        </Alert>
                                        : ""
                                    }
                                    <div className={classes.formGroup}>
                                        <TextField name="plaintiffFirstName" className={classes.formControl} variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.plaintiffFirstName}
                                                   size="small" label="First Name" onChange={(e) => {
                                            handleInputChange(e)
                                        }}/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffFirstName"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffFirstName}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffFirstName && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffFirstName}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField name="plaintiffLastName" className={classes.formControl} variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.plaintiffLastName}
                                                   size="small" label="Last Name" onChange={(e) => {
                                            handleInputChange(e)
                                        }}/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffLastName"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffLastName}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffLastName && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffLastName}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <div className={classes.formBox}>
                                            <label className={classes.selectLabel}>
                                                Date of Birth
                                            </label>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker name="plaintiffDateOfBirth" disableToolbar variant="inline"
                                                                    className={classes.formControl}
                                                                    format="MM/dd/yyyy" margin="normal" value={plaintiffDateOfBirth}
                                                                    onChange={(date) => handleDate(date, 'plaintiffDateOfBirth')}/>
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffDateOfBirth"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffDateOfBirth}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffDateOfBirth && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffDateOfBirth}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField variant="outlined" className={classes.formControl} name="plaintiffStreetAddress"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.plaintiffStreetAddress}
                                                   onChange={(e) => handleInputChange(e)} size="small" label="Street Address"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffStreetAddress"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffStreetAddress}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffStreetAddress && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffStreetAddress}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField variant="outlined" className={classes.formControl} name="plaintiffCity"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.plaintiffCity}
                                                   onChange={(e) => handleInputChange(e)} size="small" label="City"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffCity"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffCity}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffCity && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffCity}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField variant="outlined" className={classes.formControl} name="plaintiffPostalCode"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.plaintiffPostalCode}
                                                   onChange={(e) => handleInputChange(e)} size="small" label="Zipcode"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffPostalCode"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffPostalCode}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffPostalCode && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffPostalCode}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <FormControl variant="standard" className={classes.formControl}>
                                            <InputLabel id="state-label" className={classes.formControlLabel}>State</InputLabel>
                                            <Select labelId="state-label" name="plaintiffStateId"
                                                    onChange={(e) => handleInputChange(e)}
                                                    value={formData.plaintiffStateId}
                                                    className={classes.formControl}>
                                                {states.length > 0 && states.map((state) => {
                                                    return (
                                                        <MenuItem key={state.key} value={state.id}>{state.name}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffStateId"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffStateId}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffStateId && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffStateId}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl} name="plaintiffEmail"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.plaintiffEmail}
                                                   type="email"
                                                   onChange={(e) => handleInputChange(e)} variant="outlined" size="small"
                                                   label="Plaintiff Email"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffEmail"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffEmail}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffEmail && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffEmail}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField type="text" className={classes.formControl} name="plaintiffPhone"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.plaintiffPhone}
                                                   onChange={(e) => handleInputChange(e)} variant="outlined" size="small"
                                                   label="Phone Number"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="plaintiffPhone"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.plaintiffPhone}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.plaintiffPhone && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.plaintiffPhone}
                                    </span>
                                            )
                                        }
                                    </div>
                                </section>
                                <Divider className={classes.divider}/>
                                <section className={classes.draftContractSection}>
                                    <h2 className={classes.draftContractPageSubTitle}>Case Information</h2>
                                    <div className={classes.formGroup}>
                                        <TextField
                                            className={classes.formControl}
                                            name="caseId" variant="outlined" size="small"
                                            InputLabelProps={{
                                                className: classes.formControlLabel,

                                            }}
                                            value={formData.caseId}
                                            onChange={(e) => handleInputChange(e)}
                                            label="Case ID (or short description if not known)"
                                        />
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="caseId" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.caseId}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.caseId && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.caseId}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <div className={classes.formBox}>
                                            <label className={classes.selectLabel}>
                                                When is the case's expected or existing settlement date? *
                                            </label>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker name="settlementDate" disableToolbar variant="inline"
                                                                    className={classes.formControl}
                                                                    format="MM/dd/yyyy" margin="normal" value={settlementDate}
                                                                    onChange={(date) => handleDate(date, 'settlementDate')}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="settlementDate"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.settlementDate}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.settlementDate && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.settlementDate}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        {formData.contractType === "PreSettlement" &&
                                            <Alert className={classes.alert} icon={false} severity="warning" variant="outlined">
                                                <span>
                                                    Your estimated repayment amount is based on your estimated settlement date.<br></br>
                                                    Note, this is just an estimate. When repayment is ready to be submitted, please use the payoff statement feature on your client's funding page for the actual amount due at that time.
                                                </span>
                                            </Alert>
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl}
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,
                                                   }}
                                                   value={formData.opposingInsurance}
                                                   name="opposingInsurance" variant="outlined" size="small"
                                                   onChange={(e) => handleInputChange(e)}
                                                   label="Opposing Insurance"
                                        />
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="opposingInsurance"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.opposingInsurance}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.opposingInsurance && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.opposingInsurance}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl}
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,
                                                   }}
                                                   value={formData.insuranceAdjuster}
                                                   name="insuranceAdjuster" variant="outlined" size="small"
                                                   onChange={(e) => handleInputChange(e)}
                                                   label="Insurance Adjuster"
                                        />
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="insuranceAdjuster"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.insuranceAdjuster}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.insuranceAdjuster && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.insuranceAdjuster}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl}
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   name="insuranceAdjusterPhone" variant="outlined" size="small"
                                                   value={formData.insuranceAdjusterPhone}
                                                   onChange={(e) => handleInputChange(e)}
                                                   label="Insurance Adjuster Phone"
                                        />
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="insuranceAdjusterPhone"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.insuranceAdjusterPhone}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.insuranceAdjusterPhone && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.insuranceAdjusterPhone}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl}
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   name="insuranceClaim" variant="outlined" size="small"
                                                   value={formData.insuranceClaim}
                                                   onChange={(e) => handleInputChange(e)}
                                                   label="Insurance Claim"
                                        />
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="insuranceClaim"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.insuranceClaim}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.insuranceClaim && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.insuranceClaim}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <FormControl className={classes.formBox}>
                                            <InputLabel id="accepted-liability" className={classes.formControlLabel}>Accepted
                                                Liability</InputLabel>
                                            <Select
                                                labelId="accepted-liability"
                                                className={classes.formControl}
                                                name="liability"
                                                value={formData.liabilityValue}
                                                onChange={(e) => handleLiabilityChange(e)}
                                            >
                                                <MenuItem value="yes">Yes</MenuItem>
                                                <MenuItem value="no">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="liability" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           style={{marginTop: 8}}
                                                           value={commentFormData.liability}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.liability && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.liability}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <FormControl className={classes.formBox}>
                                            <InputLabel id="property-damage" className={classes.formControlLabel}>Property
                                                Damage</InputLabel>
                                            <Select
                                                labelId="property-damage"
                                                className={classes.formControl}
                                                name="propertyDamage"
                                                value={formData.propertyDamage}
                                                onChange={(e) => handleInputChange(e)}
                                            >
                                                <MenuItem value="Slight">Slight</MenuItem>
                                                <MenuItem value="Moderate">Moderate</MenuItem>
                                                <MenuItem value="Extensive">Extensive</MenuItem>
                                                <MenuItem value="None">None</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="propertyDamage"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           style={{marginTop: 8}}
                                                           value={commentFormData.propertyDamage}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.propertyDamage && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.propertyDamage}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <FormControl className={classes.formBox}>
                                            <InputLabel id="injury-level-label" className={classes.formControlLabel}>Injury
                                                Level</InputLabel>
                                            <Select labelId="injury-level-label"
                                                    className={classes.formControl}
                                                    name="injuryLevel"
                                                    value={formData.injuryLevel}
                                                    onChange={(e) => handleInputChange(e)}
                                            >
                                                <MenuItem value="Slight">Slight</MenuItem>
                                                <MenuItem value="Moderate">Moderate</MenuItem>
                                                <MenuItem value="Extensive">Extensive</MenuItem>
                                                <MenuItem value="None">None</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="injuryLevel" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           style={{marginTop: 8}}
                                                           value={commentFormData.injuryLevel}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.injuryLevel && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.injuryLevel}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <div className={classes.formBox}>
                                            <label className={classes.selectLabel}>
                                                Date of accident or injury *
                                            </label>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    name="accidentDate"
                                                    disableToolbar variant="inline"
                                                    format="MM/dd/yyyy" margin="normal"
                                                    value={accidentDate}
                                                    className={classes.formControl}
                                                    onChange={(date) => handleDate(date, 'accidentDate')}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="accidentDate" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.accidentDate}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.accidentDate && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.accidentDate}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl}
                                                   name="caseManagerEmail"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   type="email"
                                                   variant="outlined" size="small"
                                                   value={formData.caseManagerEmail}
                                                   onChange={(e) => handleInputChange(e)}
                                                   label="Case manager (email)"
                                        />
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="caseManagerEmail"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.caseManagerEmail}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.caseManagerEmail && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.caseManagerEmail}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField
                                            name="accidentDescription"
                                            label="Injury/Accident Description"
                                            InputLabelProps={{
                                                className: classes.formControlLabel,

                                            }}
                                            value={formData.accidentDescription}
                                            variant="outlined" rows={4}
                                            className={classes.formControl}
                                            onChange={(e) => handleInputChange(e)}
                                            placeholder="Write Description..."
                                            multiline
                                        />
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField
                                                    name="accidentDescription"
                                                    label="Comment"
                                                    InputLabelProps={{
                                                        className: classes.formControlLabel,

                                                    }}
                                                    value={commentFormData.accidentDescription}
                                                    variant="outlined" rows={4}
                                                    className={classes.formControl}
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder="Write Comment..."
                                                    multiline
                                                />
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.accidentDescription && (
                                                <span className={classes.adminNotesLarge}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.accidentDescription}
                                    </span>
                                            )
                                        }
                                    </div>
                                </section>
                                <Divider className={classes.divider}/>
                                <section className={classes.draftContractSection}>
                                    <h2 className={classes.draftContractPageSubTitle}>
                                        Attorney Information
                                        {
                                            isAdministrator && !!draftContract && (
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => validate('attorney')}
                                                    disabled={loaderIsActive}
                                                >
                                                    Validate
                                                </Button>
                                            )
                                        }
                                    </h2>
                                    <div className={classes.formGroup}>
                                        <TextField name="attorneyFirstName" className={classes.formControl} variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.attorneyFirstName}
                                                   size="small" label="First Name" onChange={(e) => {
                                            handleInputChange(e)
                                        }}/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="attorneyFirstName"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.attorneyFirstName}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.attorneyFirstName && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.attorneyFirstName}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField name="attorneyLastName" className={classes.formControl} variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.attorneyLastName}
                                                   size="small" label="Last Name" onChange={(e) => {
                                            handleInputChange(e)
                                        }}/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="attorneyLastName"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.attorneyLastName}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.attorneyLastName && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.attorneyLastName}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField className={classes.formControl} name="attorneyEmail"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.attorneyEmail}
                                                   type="email"
                                                   onChange={(e) => handleInputChange(e)} variant="outlined" size="small"
                                                   label="Attorney Email"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="attorneyEmail"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.attorneyEmail}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.attorneyEmail && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.attorneyEmail}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <TextField type="text" className={classes.formControl} name="attorneyPhoneNumber"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.attorneyPhoneNumber}
                                                   onChange={(e) => handleInputChange(e)} variant="outlined" size="small"
                                                   label="Phone Number"/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="attorneyPhoneNumber"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.attorneyPhoneNumber}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.attorneyPhoneNumber && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.attorneyPhoneNumber}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <FormControl variant="standard" className={classes.formControl}>
                                            <InputLabel id="state-label" className={classes.formControlLabel}>State</InputLabel>
                                            <Select labelId="state-label" name="attorneyStateId"
                                                    onChange={(e) => handleInputChange(e)}
                                                    value={formData.attorneyStateId}
                                                    className={classes.formControl}>
                                                <MenuItem value="undefined">Select</MenuItem>
                                                {states.length > 0 && states.map((state) => {
                                                    return (
                                                        <MenuItem key={state.key} value={state.id}>{state.name}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="attorneyStateId"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.attorneyStateId}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.attorneyStateId && (
                                                <span className={classes.adminNotes}>
                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                            {commentFormData.attorneyStateId}
                                            </span>
                                            )
                                        }
                                    </div>
                                </section>
                                <Divider className={classes.divider}/>
                                <section className={classes.draftContractSection}>
                                    <h2 className={classes.draftContractPageSubTitle}>
                                        Law Firm
                                        {
                                            isAdministrator && !!draftContract && (
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => validate('lawFirm')}
                                                    disabled={loaderIsActive}
                                                >
                                                    Validate
                                                </Button>
                                            )
                                        }
                                    </h2>
                                    <div className={classes.formGroup}>
                                        <TextField name="lawFirmName" className={classes.formControl} variant="outlined"
                                                   InputLabelProps={{
                                                       className: classes.formControlLabel,

                                                   }}
                                                   value={formData.lawFirmName}
                                                   size="small" label="Firm Name" onChange={(e) => {
                                            handleInputChange(e)
                                        }}/>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="lawFirmName" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.lawFirmName}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.lawFirmName && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.lawFirmName}
                                    </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <FormControl variant="standard" className={classes.formControl}>
                                            <InputLabel id="state-label" className={classes.formControlLabel}>State</InputLabel>
                                            <Select labelId="state-label" name="lawFirmStateId"
                                                    onChange={(e) => handleInputChange(e)}
                                                    value={formData.lawFirmStateId}
                                                    className={classes.formControl}>
                                                <MenuItem value="undefined">Select</MenuItem>
                                                {states.length > 0 && states.map((state) => {
                                                    return (
                                                        <MenuItem key={state.key} value={state.id}>{state.name}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="lawFirmStateId"
                                                           variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           value={commentFormData.lawFirmStateId}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.lawFirmStateId && (
                                                <span className={classes.adminNotes}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.lawFirmStateId}
                                    </span>
                                            )
                                        }
                                    </div>
                                </section>
                                <Divider className={classes.divider}/>
                                <section className={classes.draftContractSection}>
                                    <div className={classes.formGroup}>
                                        <div className={classes.formBox}>
                                            <span>Comments: </span>
                                            <TextField name="comments" variant="outlined" rows={4} className={classes.textarea}
                                                       onChange={(e) => handleInputChange(e)}
                                                       placeholder="Write comment..." multiline value={formData.comments}/>
                                        </div>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="comments" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           style={{marginTop: 28}}
                                                           value={commentFormData.comments}
                                                           multiline
                                                           rows={4}
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.comments && (
                                                <span className={classes.adminNotesLarge}
                                                      style={{marginTop: 29}}>
                                        <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.comments}
                                    </span>
                                            )
                                        }
                                    </div>
                                </section>
                                <Divider className={classes.divider}/>
                                <section className={classes.draftContractSection}>
                                    <div className={classes.formGroup}>
                                        <FormControl className={classes.formBox}>
                                            <InputLabel id="advancesWithOtherCompanies" className={classes.formControlLabel}>Do you have any other advances with other companies?</InputLabel>
                                            <Select
                                                labelId="advancesWithOtherCompanies"
                                                className={classes.formControl}
                                                name="advancesWithOtherCompanies"
                                                value={formData.advancesWithOtherCompanies ? 'yes' : 'no'}
                                                onChange={(e) => handleBooleanChange(e)}
                                            >
                                                <MenuItem value="yes">Yes</MenuItem>
                                                <MenuItem value="no">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="advancesWithOtherCompanies" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           style={{marginTop: 8}}
                                                           value={commentFormData.advancesWithOtherCompanies}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.advancesWithOtherCompanies && (
                                                <span className={classes.adminNotes}>
                                                    <WarningIcon className={classes.adminNotesIcon}/>
                                                                {commentFormData.advancesWithOtherCompanies}
                                                </span>
                                            )
                                        }
                                    </div>
                                    {
                                        formData.advancesWithOtherCompanies && (
                                            <>
                                                <div className={classes.formGroup}>
                                                    <TextField name="preSettlementCompanyName" className={classes.formControl} variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,

                                                               }}
                                                               value={formData.preSettlementCompanyName}
                                                               size="small" label="Pre-Settlement Company Name" onChange={(e) => {
                                                        handleInputChange(e)
                                                    }}/>
                                                    {
                                                        isAdministrator && !!draftContract && (
                                                            <TextField className={classes.formControlComment} name="preSettlementCompanyName"
                                                                       variant="outlined"
                                                                       InputLabelProps={{
                                                                           className: classes.formControlLabel,
                                                                       }}
                                                                       value={commentFormData.preSettlementCompanyName}
                                                                       size="small"
                                                                       onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                        )
                                                    }
                                                    {
                                                        !!draftContract && !isAdministrator && commentFormData && commentFormData.preSettlementCompanyName && (
                                                            <span className={classes.adminNotes}>
                                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                                                        {commentFormData.preSettlementCompanyName}
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                                <div className={classes.formGroup}>
                                                    <TextField name="preSettlementCompanyEmail" className={classes.formControl} variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,

                                                               }}
                                                               value={formData.preSettlementCompanyEmail}
                                                               type="email"
                                                               size="small" label="Pre-Settlement Company Email" onChange={(e) => {
                                                        handleInputChange(e)
                                                    }}/>
                                                    {
                                                        isAdministrator && !!draftContract && (
                                                            <TextField className={classes.formControlComment} name="preSettlementCompanyEmail"
                                                                       variant="outlined"
                                                                       InputLabelProps={{
                                                                           className: classes.formControlLabel,
                                                                       }}
                                                                       value={commentFormData.preSettlementCompanyEmail}
                                                                       size="small"
                                                                       onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                        )
                                                    }
                                                    {
                                                        !!draftContract && !isAdministrator && commentFormData && commentFormData.preSettlementCompanyEmail && (
                                                            <span className={classes.adminNotes}>
                                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                                                        {commentFormData.preSettlementCompanyEmail}
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                                <div className={classes.formGroup}>
                                                    <TextField name="preSettlementAmountBorrowed" className={classes.formControl} variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,

                                                               }}
                                                               value={formData.preSettlementAmountBorrowed}
                                                               size="small" label="Amount Borrowed" onChange={(e) => {
                                                        handleInputChange(e)
                                                    }}/>
                                                    {
                                                        isAdministrator && !!draftContract && (
                                                            <TextField className={classes.formControlComment} name="preSettlementAmountBorrowed"
                                                                       variant="outlined"
                                                                       InputLabelProps={{
                                                                           className: classes.formControlLabel,
                                                                       }}
                                                                       value={commentFormData.preSettlementAmountBorrowed}
                                                                       size="small"
                                                                       onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                        )
                                                    }
                                                    {
                                                        !!draftContract && !isAdministrator && commentFormData && commentFormData.preSettlementAmountBorrowed && (
                                                            <span className={classes.adminNotes}>
                                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                                                        {commentFormData.preSettlementAmountBorrowed}
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                                <div className={classes.formGroup}>
                                                    <TextField name="preSettlementAmountDue" className={classes.formControl} variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,
                                                               }}
                                                               value={formData.preSettlementAmountDue}
                                                               size="small" label="Amount Due (if known)" onChange={(e) => {
                                                        handleInputChange(e)
                                                    }}/>
                                                    {
                                                        isAdministrator && !!draftContract && (
                                                            <TextField className={classes.formControlComment} name="preSettlementAmountDue"
                                                                       variant="outlined"
                                                                       InputLabelProps={{
                                                                           className: classes.formControlLabel,
                                                                       }}
                                                                       value={commentFormData.preSettlementAmountDue}
                                                                       size="small"
                                                                       onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                        )
                                                    }
                                                    {
                                                        !!draftContract && !isAdministrator && commentFormData && commentFormData.preSettlementAmountDue && (
                                                            <span className={classes.adminNotes}>
                                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                                                        {commentFormData.preSettlementAmountDue}
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                    <div className={classes.formGroup}>
                                        <FormControl className={classes.formBox}>
                                            <InputLabel id="involvedInBancrupcy" className={classes.formControlLabel}>Are you currently involved in Bankruptcy proceedings?</InputLabel>
                                            <Select
                                                labelId="involvedInBancrupcy"
                                                className={classes.formControl}
                                                name="involvedInBancrupcy"
                                                value={formData.involvedInBancrupcy ? 'yes' : 'no'}
                                                onChange={(e) => handleBooleanChange(e)}
                                            >
                                                <MenuItem value="yes">Yes</MenuItem>
                                                <MenuItem value="no">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="involvedInBancrupcy" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           style={{marginTop: 8}}
                                                           value={commentFormData.involvedInBancrupcy}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.involvedInBancrupcy && (
                                                <span className={classes.adminNotes}>
                                                    <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.involvedInBancrupcy}
                                                </span>
                                            )
                                        }
                                    </div>
                                    <div className={classes.formGroup}>
                                        <FormControl className={classes.formBox}>
                                            <InputLabel id="preferredPaymentMethod" className={classes.formControlLabel}>If approved, how would you like to receive your funds?</InputLabel>
                                            <Select
                                                labelId="preferredPaymentMethod"
                                                className={classes.formControl}
                                                name="preferredPaymentMethod"
                                                value={formData.preferredPaymentMethod}
                                                onChange={(e) => handleSelectChange(e)}
                                            >
                                                <MenuItem value="">Select</MenuItem>
                                                <MenuItem value="ECheck">eCheck</MenuItem>
                                                <MenuItem value="ACH">ACH/Direct Deposit</MenuItem>
                                                <MenuItem value="Zelle">Zelle</MenuItem>
                                                <MenuItem value="PayPal">PayPal</MenuItem>
                                                <MenuItem value="CashApp">CashApp</MenuItem>
                                                <MenuItem value="CarrierPigeon">Carrier Pigeon</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            isAdministrator && !!draftContract && (
                                                <TextField className={classes.formControlComment} name="preferredPaymentMethod" variant="outlined"
                                                           InputLabelProps={{
                                                               className: classes.formControlLabel,
                                                           }}
                                                           style={{marginTop: 8}}
                                                           value={commentFormData.preferredPaymentMethod}
                                                           size="small"
                                                           onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                            )
                                        }
                                        {
                                            !!draftContract && !isAdministrator && commentFormData && commentFormData.preferredPaymentMethod && (
                                                <span className={classes.adminNotes}>
                                                    <WarningIcon className={classes.adminNotesIcon}/>
                                                    {commentFormData.preferredPaymentMethod}
                                                </span>
                                            )
                                        }
                                    </div>
                                    {
                                        <div className={classes.formGroup}>
                                            {formData.preferredPaymentMethod &&
                                                <Alert className={classes.alert} icon={false} severity="warning" variant="outlined">
                                                    <span>
                                                        {formData.preferredPaymentMethod === 'ECheck' && ('Usually can be delivered via email the same business day')}
                                                        {formData.preferredPaymentMethod === 'ACH' && ('Takes one business day and incurs a $50 bank fee')}
                                                        {formData.preferredPaymentMethod === 'Zelle' && ('If available - you must have a Zelle account. Usually same day transaction')}
                                                        {formData.preferredPaymentMethod === 'PayPal' && ('You must have a PayPal account. Usually same day transaction. Also incurs a $50 transfer fee.')}
                                                        {formData.preferredPaymentMethod === 'CashApp' && ('If available - you must have a CashApp account. Usually same day transaction.')}
                                                        {formData.preferredPaymentMethod === 'CarrierPigeon' && ('For this option, we put cash into an envelope and a bird flies to your destination.')}
                                                    </span>
                                                </Alert>
                                            }
                                        </div>
                                    }
                                    {
                                        formData.preferredPaymentMethod === 'ACH' && (
                                            <>
                                                <div className={classes.formGroup}>
                                                    <TextField name="paymentBankName" className={classes.formControl} variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,
                                                               }}
                                                               value={formData.paymentBankName}
                                                               size="small" label="Bank name" onChange={(e) => {
                                                        handleInputChange(e)
                                                    }}/>
                                                    {
                                                        isAdministrator && !!draftContract && (
                                                            <TextField className={classes.formControlComment} name="paymentBankName"
                                                                       variant="outlined"
                                                                       InputLabelProps={{
                                                                           className: classes.formControlLabel,
                                                                       }}
                                                                       value={commentFormData.paymentBankName}
                                                                       size="small"
                                                                       onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                        )
                                                    }
                                                    {
                                                        !!draftContract && !isAdministrator && commentFormData && commentFormData.paymentBankName && (
                                                            <span className={classes.adminNotes}>
                                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                                {commentFormData.paymentBankName}
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                                <div className={classes.formGroup}>
                                                    <TextField name="paymentRoutingNumber" className={classes.formControl} variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,

                                                               }}
                                                               value={formData.paymentRoutingNumber}
                                                               size="small" label="Routing Number (9 digits)" onChange={(e) => {
                                                        handleInputChange(e)
                                                    }}/>
                                                    {
                                                        isAdministrator && !!draftContract && (
                                                            <TextField className={classes.formControlComment} name="paymentRoutingNumber"
                                                                       variant="outlined"
                                                                       InputLabelProps={{
                                                                           className: classes.formControlLabel,
                                                                       }}
                                                                       value={commentFormData.paymentRoutingNumber}
                                                                       size="small"
                                                                       onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                        )
                                                    }
                                                    {
                                                        !!draftContract && !isAdministrator && commentFormData && commentFormData.paymentRoutingNumber && (
                                                            <span className={classes.adminNotes}>
                                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                                {commentFormData.paymentRoutingNumber}
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                                <div className={classes.formGroup}>
                                                    <TextField name="paymentAccountNumber" className={classes.formControl} variant="outlined"
                                                               InputLabelProps={{
                                                                   className: classes.formControlLabel,

                                                               }}
                                                               value={formData.paymentAccountNumber}
                                                               size="small" label="Account Number" onChange={(e) => {
                                                        handleInputChange(e)
                                                    }}/>
                                                    {
                                                        isAdministrator && !!draftContract && (
                                                            <TextField className={classes.formControlComment} name="paymentAccountNumber"
                                                                       variant="outlined"
                                                                       InputLabelProps={{
                                                                           className: classes.formControlLabel,
                                                                       }}
                                                                       value={commentFormData.paymentAccountNumber}
                                                                       size="small"
                                                                       onChange={(e) => handleInputCommentChange(e)} label="Comment"/>
                                                        )
                                                    }
                                                    {
                                                        !!draftContract && !isAdministrator && commentFormData && commentFormData.paymentAccountNumber && (
                                                            <span className={classes.adminNotes}>
                                                                <WarningIcon className={classes.adminNotesIcon}/>
                                                                {commentFormData.paymentAccountNumber}
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                </section>
                                {
                                    isAdministrator && draftContract && (
                                        <section className={classes.draftContractSection}>
                                            <div className={classes.formGroup}>
                                                <div className={classes.formLargeBox}>
                                                    <span>Status Comment: </span>
                                                    <TextField name="comments" variant="outlined" rows={4} className={classes.textarea}
                                                               onChange={(e) => handleStatusComments(e)}
                                                               placeholder="Write comment..." multiline value={statusComments}/>
                                                </div>
                                            </div>
                                        </section>
                                    )
                                }
                                {
                                    draftContract && (
                                        <>
                                            <div className={classes.submitSection}>
                                                {isAdministrator && (
                                                    <>
                                                        <Button
                                                            type="button"
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={reject}
                                                            disabled={loaderIsActive}
                                                        >
                                                            Reject
                                                        </Button>
                                                        {/*<Button*/}
                                                        {/*    type="button"*/}
                                                        {/*    variant="contained"*/}
                                                        {/*    color="default"*/}
                                                        {/*    onClick={requestChanges}*/}
                                                        {/*    disabled={loaderIsActive}*/}
                                                        {/*>*/}
                                                        {/*    Request changes from Client*/}
                                                        {/*</Button>*/}
                                                        {/*<Button*/}
                                                        {/*    type="button"*/}
                                                        {/*    variant="contained"*/}
                                                        {/*    color="default"*/}
                                                        {/*    onClick={requestAttorneyChanges}*/}
                                                        {/*    disabled={loaderIsActive}*/}
                                                        {/*>*/}
                                                        {/*    Request info from Attorney*/}
                                                        {/*</Button>*/}
                                                        <Button
                                                            type="button"
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={approve}
                                                            disabled={loaderIsActive}
                                                        >
                                                            Approve
                                                        </Button>
                                                        <Button
                                                            type="submit"
                                                            variant="contained"
                                                            color="default"
                                                            disabled={loaderIsActive}
                                                        >
                                                            Update
                                                        </Button>
                                                    </>
                                                )}

                                                {loaderIsActive && <Preloader size="30" position="center"/>}
                                            </div>
                                        </>
                                    )
                                }
                                {
                                    (!draftContract) && (
                                        <div className={classes.submitSection}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                disabled={loaderIsActive}
                                            >
                                                Submit
                                            </Button>
                                            {loaderIsActive && <Preloader size="30" position="center"/>}
                                        </div>
                                    )
                                }
                            </form>
                        </Container>
                        <Modal
                            open={isMismatchInfoModalOpen}
                            onClose={() => setIsMismatchInfoModalOpen(false)}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >
                            <Fade in={isMismatchInfoModalOpen}>
                                <Box className={classes.modalWindow}>
                                    <Typography variant="h3" style={{marginBottom: 20}}>
                                        Mismatch Information
                                    </Typography>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="left">Actual Data</StyledTableCell>
                                                    <StyledTableCell align="left">System Data</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {mismatchData.length > 0 && mismatchData.map((mismatchDataItem: any) => (
                                                    <StyledTableRow key={mismatchDataItem.id}>
                                                        <StyledTableCell
                                                            align="left" style={{ 'background': mismatchDataItem.actualValue !== mismatchDataItem.systemValue ? 'rgb(255, 59, 59)' : 'transparent'}}>{mismatchDataItem.actualValue}</StyledTableCell>
                                                        <StyledTableCell
                                                            align="left" style={{ 'background': mismatchDataItem.actualValue !== mismatchDataItem.systemValue ? 'rgb(255, 59, 59)' : 'transparent'}}>{mismatchDataItem.systemValue}</StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Fade>
                        </Modal>
                        <Modal
                            open={isApprovedContractModalOpen}
                            onClose={() => setIsApprovedContractModalOpen(false)}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >
                            <Fade in={isApprovedContractModalOpen}>
                                <Box className={classes.modalWindow}>
                                    <Typography variant="h4" style={{marginBottom: 20}}>
                                        Draft approved
                                    </Typography>
                                    <Typography variant="body1" style={{ marginBottom: 20}}>
                                        This contract has been approved.
                                    </Typography>
                                    <NavLink to={`/contract-page?${contractId}`}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                        >
                                            View Contract
                                        </Button>
                                    </NavLink>
                                </Box>
                            </Fade>
                        </Modal>
                    </>
                )
            }
        </>
    )
}
